export default {"src":"/_next/static/media/our-partners-img-four.56f0da37.svg","height":76,"width":135};